import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(PIXEL_ID);
  return <div className="min-h-screen w-full bg-white font-sans text-graphite selection:bg-gold/40" data-id="element-0" data-mp="28suumo7jhzm9">
      <noscript data-id="element-1" data-mp="23ujho4ly78zt">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="23v2td3l0915e" />
      </noscript>

      <Hero data-id="element-3" data-mp="3mj6lg27aoaim" />
      <main data-id="element-4" data-mp="3rcj6k2crlz6m">
        <ProblemSection data-id="element-5" data-mp="3rbrcivytg9ig" />
        <SolutionSection data-id="element-6" data-mp="3rdkg22e4udm8" />
        <BonusesSection data-id="element-7" data-mp="3recedkz46pg7" />
        <BenefitsSection data-id="element-8" data-mp="5osn3wyp084" />
        <OfferSection data-id="element-9" data-mp="682dxcgkib2" />
        <GuaranteeSection data-id="element-10" data-mp="5gfdawxfswe" />
        <Testimonials data-id="element-11" data-mp="7suzhf7pr6a" />
        <FAQSection data-id="element-12" data-mp="2zld1r8m3ndb0" />
        <FinalCTA data-id="element-13" data-mp="2zm4y4lnitf2c" />
      </main>
      <Footer data-id="element-14" data-mp="2zmwit1fkxsdu" />
      <PurchasePopup data-id="element-15" data-mp="2zng1ikd20ksx" />
    </div>;
}